import { homeownerGraceView } from '../shared/planLimits';
import { isNativeApp, NATIVE_PLAN_NOTICE } from '../utils/platform';

const buttonStyle = {
  background: '#59c4c4',
  color: '#fff',
  border: 'none',
  borderRadius: '8px',
  padding: '0.55rem 0.9rem',
  fontWeight: 700,
  cursor: 'pointer',
};

/**
 * Days left and the homeowner count next to the Solo 200 limit.
 * Buy and archive actions appear only when the count is still unknown or
 * already over that limit. Phone and desktop use this same message.
 */
export default function HomeownerGraceBanner({
  profile,
  used,
  colors,
  onBuyPlus,
  onBuyMax,
  onArchive,
}) {
  const view = homeownerGraceView(profile, used);
  if (!view) return null;
  const native = isNativeApp();
  const message = native
    ? view.message.replace('Buy Plus or Max, or archive homeowners. ', '')
    : view.message;
  return (
    <div
      role="status"
      style={{
        background: '#fffbeb',
        border: `1px solid ${(colors && colors.border) || '#f59e0b'}`,
        borderRadius: '8px',
        padding: '1rem',
        marginBottom: '1rem',
      }}
    >
      <p style={{ margin: view.showActions ? '0 0 0.75rem' : 0, color: '#92400e', fontSize: '0.95rem' }}>{message}</p>
      {native && view.showActions ? (
        <p style={{ margin: '0 0 0.75rem', color: '#92400e', fontSize: '0.95rem' }}>{NATIVE_PLAN_NOTICE}</p>
      ) : null}
      {view.showActions ? (
        <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
          {!native && <button type="button" onClick={onBuyPlus} style={buttonStyle}>Buy Plus</button>}
          {!native && <button type="button" onClick={onBuyMax} style={buttonStyle}>Buy Max</button>}
          <button type="button" onClick={onArchive} style={buttonStyle}>Archive homeowners</button>
        </div>
      ) : null}
    </div>
  );
}
